import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { getPathAfterLogin } from '../configs/config';
import { useSelector } from '../redux/store';

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const isAuthenticated = window.localStorage.getItem('auth-token');
  const { user } = useSelector((state) => state.login);

  if (isAuthenticated && user?.company_config?.onboarded_user !== true) {
    return <Navigate to={'/onboarding/1'} />;
  }
  if (isAuthenticated) {
    return <Navigate to={getPathAfterLogin()} replace />;
  }

  return <>{children}</>;
}
